import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/helmetAudit/helmetAuditHome/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/helmetAudit/helmetAuditHome',
    exact: true,
    meta: {
      title: '闪送'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/helmetAudit/helmetGather/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/helmetAudit/helmetGather',
    meta: {
      title: '闪送'
    }
  }
]
